/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-lock': {
    width: 72,
    height: 72,
    viewBox: '0 0 72 72',
    data: '<path pid="0" d="M57 31v1H42.325A7 7 0 0136 36v-1a6 6 0 005.422-3.429l.271-.571H57zm1-1v-2a1 1 0 00-1-1H41.693l-.271-.571A6 6 0 1036 35v1a7 7 0 116.325-10H57a2 2 0 012 2v2a2 2 0 01-2 2v-1a1 1 0 001-1z" _fill="#005BA5"/><path pid="1" d="M49 12a2 2 0 012 2v12h-2V14H23v44h26V32h2v26l-.01.204a2 2 0 01-1.786 1.785L49 60H23l-.204-.01a2 2 0 01-1.785-1.786L21 58V14a2 2 0 012-2h26z" _fill="#005BA5"/><path pid="2" d="M38.5 44a2.5 2.5 0 10-3.866 2.092l.33.217-.135.372-2.115 5.819h6.572l-2.116-5.82-.136-.371.332-.217A2.496 2.496 0 0038.5 44zm.5 0a2.995 2.995 0 01-1.36 2.51L40 53h-8l2.36-6.49A3 3 0 1139 44z" _fill="#005BA5"/>'
  }
})
